// Avatar feature API client — persists the signed-in member's chosen avatar.
// Mirrors PATCH /api/v1/members/me/avatar (api/routers/members.py); the response
// is the full member profile with the composed `avatar` object.
import { apiClient } from "@/lib/api-client";
import type { AvatarConfig } from "./catalog";

export interface MemberProfileWithAvatar {
  id: string;
  name: string;
  initials: string;
  division: string;
  role: string;
  is_admin: boolean;
  reputation: number;
  avatar: AvatarConfig;
}

/** Persist the current user's avatar config. Requires an authenticated session. */
export async function updateAvatar(
  config: AvatarConfig,
): Promise<MemberProfileWithAvatar> {
  return apiClient<MemberProfileWithAvatar>("/api/v1/members/me/avatar", {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(config),
  });
}
